//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const PurgingSubmissionsActive: FeatureFlag = {"Id":"PurgingSubmissionsActive","Label":"Purging expired submissions enabled","Impact":"Enable the expire submission feature","Mode":0,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":1};
